import { render, staticRenderFns } from "./product_meta_description.vue?vue&type=template&id=37db0358&"
import script from "./product_meta_description.vue?vue&type=script&lang=js&"
export * from "./product_meta_description.vue?vue&type=script&lang=js&"
import style0 from "./product_meta_description.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports